import { Types } from '@store/types';

const initialState = [];

const MarketReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.STORE_MARKET_LIST:
			return [...initialState, ...action.payload];
		default:
			return state;
	}
};

export default MarketReducer;
